type T = (key: string) => string | null;

const f: T = (key) => {
    return window.localStorage.getItem(key);
};

export default f;
